import Vue from 'vue';

//helper app
import './Components/Helpers/HelperComponent';

// Dashboard
Vue.component('dashboard', require('./Components/Views/Dashboard/Default').default);

/**
 * all component of GUD
 */
Vue.component('personal-information', require('./Components/Views/Auth/PersonalInformation').default);
Vue.component('password-change', require('./Components/Views/Auth/PasswordChange').default);
Vue.component('social-links', require('./Components/Views/Auth/SocialLinks').default);
Vue.component('login', require('./Components/Views/Auth/Login').default);
Vue.component('password-reset', require('./Components/Views/Auth/PasswordReset').default);
Vue.component('reset-password', require('./Components/Views/Auth/ResetPassword').default);
Vue.component('registration', require('./Components/Views/Auth/Registration').default);
Vue.component('my-profile', require('./Components/Views/Auth/Profile').default);

// Reports
Vue.component('app-client-report', require('./Components/Views/Reports/ClientReport').default);
Vue.component('app-global-report', require('./Components/Views/Reports/GlobalReport').default);

// Settings
Vue.component('app-setting', require('./Components/Views/Settings/Index').default);
Vue.component('general-setting', require('./Components/Views/Settings/GeneralSetting').default);
Vue.component('email-setting', require('./Components/Views/Settings/EmailSetting').default);
Vue.component('sms-setting', require('./Components/Views/Settings/SmsSetting').default);
Vue.component('google-re-captcha-setting', require('./Components/Views/Settings/GoogleRecaptchaSetting').default);
Vue.component('notification-settings', require('./Components/Views/Settings/Notification/Settings/Index').default);
Vue.component('database-template', require('./Components/Views/Settings/Notification/Template/DatabaseTemplate').default);
Vue.component('mail-template', require('./Components/Views/Settings/Notification/Template/MailTemplate').default);
Vue.component('payment-method', require('./Components/Views/Settings/PaymentMethod/PaymentMethod').default);
Vue.component('payment-method-create-edit-modal', require('./Components/Views/Settings/PaymentMethod/PaymentMethodCreateEditModal').default);

// User and Roles
Vue.component('user-roles', require('./Components/Views/UserRoles/Index').default);
Vue.component('group-of-users', require('./Components/Views/UserRoles/Roles/GroupOfUsers').default);

// Users Management
Vue.component('user-management', require('./Components/Views/Users/Index').default);
Vue.component('user-add-edit-modal', require('./Components/Views/Users/UserAddEditModal').default);

// Trips Management
Vue.component('trip-management', require('./Components/Views/Trips/Index').default);
Vue.component('control-trip-management', require('./Components/Views/Trips/Control').default);
Vue.component('trip-add-edit-modal', require('./Components/Views/Trips/TripAddEditModal').default);
Vue.component('convoy-add-edit-modal', require('./Components/Views/Trips/ConvoyAddEditModal').default);
Vue.component('trip-device-assignment-modal', require('./Components/Views/Trips/TripDeviceAssignmentModal').default);
Vue.component('trip-device-cell', require('./Components/Views/Trips/TripDeviceCell').default);
Vue.component('control-room-alert-cell', require('./Components/Views/Trips/ControlRoomAlertCell').default);
Vue.component('trip-convoy-cell', require('./Components/Views/Trips/TripConvoyCell').default);
Vue.component('trip-current-position-modal', require('./Components/Views/Trips/TripCurrentPositionModal').default);
Vue.component('add-truck-event-modal', require('./Components/Views/Trips/AddTruckEventModal').default);
Vue.component('bulk-truck-event-modal', require('./Components/Views/Trips/BulkTruckEventModal').default);
Vue.component('escorter-modal', require('./Components/Views/Trips/EscorterModal').default);
Vue.component('event-timeline-modal', require('./Components/Views/Trips/EventTimelineModal').default);

// Escorter Management
Vue.component('escorter-management', require('./Components/Views/Escorters/Index').default);
Vue.component('escorter-details', require('./Components/Views/Escorters/EscorterDetails').default);
Vue.component('escorter-personal-info', require('./Components/Views/Escorters/EscorterPersonalInfo').default);
Vue.component('escorter-add-edit-modal', require('./Components/Views/Escorters/EscorterAddEditModal').default);
Vue.component('escorter-photo', require('./Components/Views/Escorters/EscorterPhoto').default);
Vue.component('escorter-card', require('./Components/Views/Escorters/EscorterCard').default);

// Layouts
Vue.component('app-top-bar', require('./Components/Views/Layouts/Nabar').default);
Vue.component('app-sidebar', require('./Components/Views/Layouts/Sidebar').default);

// notifications
Vue.component('all-notification', require('./Components/Views/Auth/Notification').default);

Vue.component('re-captcha', require('./Components/Views/Auth/ReCaptcha').default);
Vue.component('payment-view', require('./Components/Views/Demo/Pages/PaymentMethodView').default);

//Custom Table
Vue.component('app-custom-tables', require('./Components/Views/Settings/CustomTable/CustomTable').default)
Vue.component('app-custom-table-modal', require('./Components/Views/Settings/CustomTable/CustomTableModal').default)

// Dynamic table
Vue.component('app-custom-table-dynamic', require('./Components/Views/Demo/CustomTable/DynamicPage').default)

// Floating Context Menus
Vue.component('trip-context-menu', require('./Components/Views/Context/TripContextMenu').default)

// Location
Vue.component('location', require('./Components/Views/Location/Index').default);
Vue.component('location-add-edit-modal', require('./Components/Views/Location/LocationAddEditModal').default);
Vue.component('site-management', require('./Components/Views/Sites/Index').default);
Vue.component('site-add-edit-modal', require('./Components/Views/Sites/SiteAddEditModal').default);
Vue.component('destination-management', require('./Components/Views/Destinations/Index').default);
Vue.component('destination-add-edit-modal', require('./Components/Views/Destinations/DestinationAddEditModal').default);

Vue.component('face-recognition', require('./Components/Views/Recognition/Index').default);// Incident
Vue.component('incident', require('./Components/Views/Incident/Index').default);
Vue.component('incident-add-edit-modal', require('./Components/Views/Incident/IncidentAddEditModal').default);
Vue.component('incident-report-preview-drawer', require('./Components/Views/Incident/IncidentReportPreviewDrawer').default);
Vue.component('incident-trip-live-tracking-cell', require('./Components/Views/Incident/IncidentTripLiveTrackingCell').default);
